import { Directive, ElementRef, OnInit } from '@angular/core';

import styles from './vb-ui-radio-btn-group.module.less';

/**
 * <div vbUiRadioBtnGroup aria-label="Access Type">
			<button
				type="button"
				[(ngModel)]="buttonValue"
				vbUiRadioBtn="Public">
				Public
			</button>
			<button
				type="button"
				[(ngModel)]="buttonValue"
				vbUiRadioBtn="AllUser">
				All User
			</button>
			<button
				type="button"
				[(ngModel)]="buttonValue"
				vbUiRadioBtn="Private">
				Private
			</button>
 * </div>
 */

@Directive({
	selector: '[vbUiRadioBtnGroup]',
	host: {
		'[class]': 'styles.btnToggleWrapper',
		role: 'radiogroup',
	},
	standalone: false
})
export class VbUiRadioBtnGroupDirective implements OnInit {
	public readonly styles = styles;

	constructor(
		private readonly el: ElementRef
	) { }

	public ngOnInit(): void {
		const e = this.el.nativeElement as HTMLElement;
		if(!e.getAttribute('aria-label') && !e.getAttribute('aria-labelledby')) {
			console.log('vbUiRadioBtnGroup is missing a label', e);
		}
	}

}
